export const USER_SEGMENTATION_PATHS = [
    /\/product-philosophy\/ingredient-library\/.+/,
    /\/test-user-segmentation/
];
